/* Copyright (c) 2026 Xperi. All Rights Reserved. */

/**
 * Stage-visibility resolver — a pure function answering exactly one question:
 * is this lifecycle stage allowed to be visible in this build environment?
 *
 * It reads nothing (no DeviceFeatures, no storage, no override, no network) and
 * depends on neither React nor Redux. This is what guarantees production
 * safety: a testing/development stage can never be visible in PRODUCTION, so a
 * service value can never widen a lifecycle restriction downstream. Only the
 * explicit `RELEASED` stage is visible in production.
 *
 * Matrix:
 *   Stage            Development   Production
 *   DISABLED             false        false
 *   IN_DEVELOPMENT        true        false
 *   IN_TESTING            true        false
 *   RELEASED              true         true
 */

import { BuildEnvironment, FeatureStage } from "./types";

export function resolveStageVisibility(
  stage: FeatureStage,
  environment: BuildEnvironment
): boolean {
  if (stage === FeatureStage.DISABLED) {
    return false;
  }
  if (stage === FeatureStage.RELEASED) {
    return true;
  }
  return environment === BuildEnvironment.DEVELOPMENT;
}
